import DatePickerDropdown from "ui/common/components/input/DatePickerDropdown/DatePickerDropdown";
import useDateRangeFilter from "./hooks/useDateRangeFilter";
import { DateRange } from "react-day-picker";
import { format } from "date-fns";
import clsx from "clsx";

export interface DateRangeFilterDropdownProps {
    className?: string;
    style?: React.CSSProperties;
}

export default function DateRangeFilterDropdown({ style, className }: DateRangeFilterDropdownProps) {
    const setFilters = useDateRangeFilter()[1];

    function handleApply(range: DateRange | undefined) {
        if (!range || !range.from || !range.to) setFilters({ startDate: "", endDate: "", page: "0" });
        else setFilters({ startDate: format(range.from, "dd/MM/yyyy"), endDate: format(range.to, "dd/MM/yyyy"), page: "1" });
    }

    function handleReset() {
        setFilters({ startDate: "", endDate: "", page: "0" });
    }

    return (
        <DatePickerDropdown
            className={clsx(className, "date-range-filter-dropdown")}
            mode="range"
            onApply={handleApply}
            onReset={handleReset}
            style={style}
        />
    );
}
